// Rankings-specific config, ported from renderers-rankings.js. Unlike Stats' own
// Age/Height/Weight filters (player-relative offsets), a Ranking spans the whole
// database, so these are ABSOLUTE ranges — per direct instruction, rankings aren't
// linked to a reference player. Domains are the real population's actual spread
// (15–42y, 151–185cm, 48–81kg), sanity-checked against the snapshot. Passed as the
// trailing `rangeFilters` arg to every StatsFilterKit range function so the same
// chip/slider system drives a differently-shaped config without duplication.

import type { RangeFilterConfig } from "../engines/stats-filter-kit.js";
import { ageFromDob } from "./squad-view.js";
import { LIVE_RANGE_FILTERS } from "../live/stats-files.js";

export const RANKING_RANGE_FILTERS: RangeFilterConfig = {
  age: {
    label: "Age range",
    chipLabel: "Age",
    unit: "y",
    relative: false,
    domain: { min: 15, max: 42 },
    getValue: (p) => ageFromDob(p.dob ?? null),
  },
  height: {
    label: "Height range",
    chipLabel: "Height",
    unit: "cm",
    relative: false,
    domain: { min: 151, max: 185 },
    getValue: (p) => (typeof p.height === "number" ? p.height : null),
  },
  weight: {
    label: "Weight range",
    chipLabel: "Weight",
    unit: "kg",
    relative: false,
    domain: { min: 48, max: 81 },
    getValue: (p) => (typeof p.weight === "number" ? p.weight : null),
  },
};

// --- ?live=1 (the Stats files) -------------------------------------------------------

/** The live chips, in Ben's add-menu order: the ones the files have data for. League waits for
 *  Q-010; Height, Weight and Preferred Foot stay hidden on real data (Q-013, as the Stats tile).
 *  Minutes is rules.md's chip for every module (no floor by default; added, it starts at 150+). */
export const LIVE_RANKING_CHIPS = ["league", "position", "club", "nationality", "foot", "age", "height", "weight", "minutes"] as const;

/** Ben's absolute ranges + the Minutes chip. Height / Weight stay in so a chip carried over from a
 *  saved dashboard still reads right (and honestly matches nobody: the files have no heights). */
export const LIVE_RANKING_RANGE_FILTERS: RangeFilterConfig = {
  ...RANKING_RANGE_FILTERS,
  minutes: LIVE_RANGE_FILTERS.minutes!,
};
